export default __webpack_public_path__ + "static/media/breeze.26b6051c.png";